import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "../../lib/api";

export default function AdminMagic() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token") || "";
    api.get(`/auth/magic/consume?token=${encodeURIComponent(token)}`)
      .then(() => navigate("/admin", { replace: true }))
      .catch((err) => setError(formatApiError(err)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-ivory flex items-center justify-center px-6">
      <div className="bg-white border border-sandstone p-10 max-w-md text-center" data-testid="admin-magic-status">
        {error ? (
          <>
            <h1 className="font-serif text-2xl font-semibold text-charcoal">Link not accepted</h1>
            <p className="mt-3 text-sm text-charcoal/70">{error}</p>
            <Link to="/admin/login" className="mt-6 inline-block text-sm text-forest underline" data-testid="magic-back-to-login">
              Back to sign in
            </Link>
          </>
        ) : (
          <p className="text-charcoal/70">Signing you in…</p>
        )}
      </div>
    </div>
  );
}
